import {
    FETCH_USERS,
    FETCH_USERS_FAIL,
    FETCH_USERS_SUCCESS
} from './actionTypes';

const initialState = {
    data: [],
    error: null,
    loading: false,
    loaded: false
};

export function usersListReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_USERS:
            return {
                ...initialState,
                loading: true
            };
        case FETCH_USERS_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loaded: true,
                loading: false
            };
        case FETCH_USERS_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        default:
            return state;
    }
}
